export default function Converting_a_Table_to_Range() {
  return <div>Excel_Converting_a_Table_to_Range</div>;
}
